// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__QwD+f","text":"Footer_text__mxpCv"};